// extracted by mini-css-extract-plugin
export default {"wrapper":"styles_wrapper__DtRFM","title":"styles_title__-jOcv","description":"styles_description__pbGAy"};